module.exports = __webpack_public_path__ + "img/initial-zhans.1b418b09.png";